import { Injectable } from '@angular/core';
import instantsearch from 'instantsearch.js/es';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstantSearchService {

  search: instantsearch;
  constructor() {
    this.search = instantsearch(environment.instantSearchKeys);
  }

}
